import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("BentoGridWidget", {
  title: "Bento Grid",
});
